import { render, staticRenderFns } from "./IndexPurchaseImageTable.vue?vue&type=template&id=a23a8e14&"
import script from "./IndexPurchaseImageTable.vue?vue&type=script&lang=js&"
export * from "./IndexPurchaseImageTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports